import getPermissionsLocal from "./dto/get-permissions-local";

const localRbacRepository = {
    getPermissions: getPermissionsLocal
};

export default localRbacRepository;
